<template>
    <div v-if="opened" class="availability">
        <div class="window p-5">
            <div class="row">
                <div class="col-sm-5">
                    <h4 class="bold mb-3">Date range</h4>

                    <date-range
                        :from="dateFrom"
                        :to="dateTo"
                        fromLabel="From"
                        toLabel="To"
                        :disabledTo="disabledTo"
                        @setFrom="setFrom"
                        @setTo="setTo"
                    ></date-range>
                </div>
<!--
                <div class="col-sm-7">
                    <h4 class="d-flex align-items-center bold mb-3">People</h4>
                    <price-counters @mathDone="filterPeople"></price-counters>
                </div> -->
            </div>

            <div class="row">
                <div class="mt-5 ml-auto">
                    <button type="button" class="btn ok wider" @click="closeAvailability">Check Availability</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import PriceCounters from './PriceCounters'
    import DateRange from '@/tools/DateRange'

    export default {
        props: {
            opened: Boolean,
            newReservationSetup: Object,
        },
        data: function() {
            return {
                from: null,
                to: null,
                isOpened: this.opened,
            }
        },
        created: function() {
            this.from = moment();
            this.to = moment().add(7, 'days');
        },
        computed: {
            ...mapGetters([
                'reservation',
                'getEvents',
            ]),
            dateFrom: function() {
                return this.newReservationSetup.from ? moment(this.newReservationSetup.from) : moment();
            },
            dateTo: function() {
                return this.newReservationSetup.to ? moment(this.newReservationSetup.to) : moment().add(7, 'days');
            },
            disabledTo: function() {
                return this.dateFrom.toDate();
            }
        },
        methods: {
            ...mapActions([
                'updateNewReservationSetup',
                'initEvents'
            ]),
            filterPeople: function() {
                //this.updateList({ pax: filtered.filter(e => (e.spots.total - e.spots.taken) >= total) });
            },
            setFrom: function(date) {
                var from = moment(date);
                var to = this.dateTo;

                if (from.diff(to) > 0) {
                    to = from;
                }

                this.to = to;
                this.from = from;

                this.applyRangeFilters();
            },
            setTo: function(date) {
                this.to = moment(date);

                this.applyRangeFilters();
            },
            applyRangeFilters() {
                const from = this.formatDate(this.from);
                const to = this.formatDate(this.to);

                console.log('Applying range filters with', from, to);

                this.initEvents({ from: from, to: to }).then(() => {
                    this.updateNewReservationSetup({
                        from: from,
                        to: to
                    });
                });
            },
            closeAvailability: function() {
                this.isOpened = false;
                this.$emit('closeAvailability', this.isOpened);
            }
        },
        components: {
            PriceCounters,
            DateRange,
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .availability {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.3);
        z-index: 5;

        .window {
            background: $lightest;
        }

        .counters {
            display: block;
            background: $lightest;
            border: 0;

            > li {
                display: flex;
                align-items: center;
                text-align: left;
                border: 0;
                padding: 0 0 1rem;

                .title {
                    display: flex;
                    flex-grow: 1;

                    > h6 {

                        width: 100%;
                    }
                }

                .calculator {
                    margin: 0;
                    flex-grow: 0;
                }

            }
        }

        .total {
            color: $dark;
        }
    }
</style>



// WEBPACK FOOTER //
// Availability.vue?585c662e